import { tuple } from '../_util/type';
const Themes = tuple('default', 'surround'); // custom
